module.exports = __webpack_public_path__ + "assets/img/keyboard.fa4d0bf0.png";